import { render, staticRenderFns } from "./person-short-card.vue?vue&type=template&id=2ccea2e6&scoped=true&lang=pug&"
import script from "./person-short-card.vue?vue&type=script&lang=js&"
export * from "./person-short-card.vue?vue&type=script&lang=js&"
import style0 from "./person-short-card.vue?vue&type=style&index=0&id=2ccea2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccea2e6",
  null
  
)

export default component.exports